import type { NamespaceCatalog } from '@/i18n/ns';

// A truthful wait state, not a percentage or an estimate of time remaining.
const copy: NamespaceCatalog<'summarizing'> = {
  en: { summarizing: 'Summarizing earlier messages so we can continue…' },
  sv: { summarizing: 'Sammanfattar tidigare meddelanden så att vi kan fortsätta…' },
  bg: { summarizing: 'Обобщаваме по-ранните съобщения, за да можем да продължим…' },
  cs: { summarizing: 'Shrnujeme předchozí zprávy, abychom mohli pokračovat…' },
  da: { summarizing: 'Opsummerer tidligere beskeder, så vi kan fortsætte…' },
  de: { summarizing: 'Frühere Nachrichten werden zusammengefasst, damit wir fortfahren können…' },
  el: { summarizing: 'Συνοψίζουμε τα προηγούμενα μηνύματα για να συνεχίσουμε…' },
  es: { summarizing: 'Resumiendo los mensajes anteriores para poder continuar…' },
  et: { summarizing: 'Teeme varasematest sõnumitest kokkuvõtte, et saaksime jätkata…' },
  fi: { summarizing: 'Tiivistetään aiempia viestejä, jotta voimme jatkaa…' },
  fr: { summarizing: 'Résumé des messages précédents pour pouvoir continuer…' },
  ga: {
    summarizing:
      'Achoimre á déanamh ar theachtaireachtaí roimhe seo ionas gur féidir linn leanúint ar aghaidh…',
  },
  hr: { summarizing: 'Sažimamo ranije poruke kako bismo mogli nastaviti…' },
  hu: { summarizing: 'Összefoglaljuk a korábbi üzeneteket, hogy folytathassuk…' },
  it: { summarizing: 'Riepilogo dei messaggi precedenti per poter continuare…' },
  lt: { summarizing: 'Apibendriname ankstesnes žinutes, kad galėtume tęsti…' },
  lv: { summarizing: 'Apkopojam iepriekšējos ziņojumus, lai varētu turpināt…' },
  mt: { summarizing: 'Qed niġbru fil-qosor il-messaġġi ta’ qabel biex inkunu nistgħu nkomplu…' },
  nl: { summarizing: 'Eerdere berichten worden samengevat zodat we verder kunnen…' },
  pl: { summarizing: 'Podsumowujemy wcześniejsze wiadomości, aby móc kontynuować…' },
  pt: { summarizing: 'A resumir as mensagens anteriores para podermos continuar…' },
  ro: { summarizing: 'Rezumăm mesajele anterioare pentru a putea continua…' },
  sk: { summarizing: 'Zhŕňame predchádzajúce správy, aby sme mohli pokračovať…' },
  sl: { summarizing: 'Povzemamo prejšnja sporočila, da lahko nadaljujemo…' },
};
export default copy;
